<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'ESTADOS.LBL_ESTADOS' | translate}}" *ngIf="estado">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{estado.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_ESTADOINICIAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorEstadoInicial ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_ESTADOFINAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorEstadoFinal ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_ESTADOAPROBADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorAprobado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_UNIDADCREDITO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorUnidadCredito ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_CANCELA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorCancela ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_CHECKDOCUMENTAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorCheckDocumental ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_ESTADODESEMBOLSO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorDesembolso ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_ALIADO' | translate }}
            :</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorAliado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_ESTADOPERFILAMOS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorPerfilado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_FABRICACREDITO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorFabricaCredito ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_BLOQUEADOSARLAFT' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorBloqueadoSarlaft ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_CALIFICARREFERENCIAS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estado.indicadorCalificarReferencias ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid" *ngIf="carImagen || imagen">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTADOS.LBL_ICONO' | translate }}:</label>
          <div class="lg:col-3 col-6 md:col-8">
            <img alt="" style="width: 100px; max-height: 100px"
                 [src]="!carImagen ? imagen : '/assets/images/loader.gif'"/>
          </div>
        </div>
      </p-panel>
      <p-panel header="{{ 'ESTADOSROL.LBL_ESTADOROL' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnas"
                     [value]="lisEstadoRol"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreRol}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
      <p-panel header="{{ 'ESTADOSCAUSAL.LBL_CONFIGURACIONESCAUSALES' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colCausal"
                     [value]="lisEstadoCausal"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.causalSolicitud}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
